exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-cs-js": () => import("./../../../src/pages/cs.js" /* webpackChunkName: "component---src-pages-cs-js" */),
  "component---src-pages-de-js": () => import("./../../../src/pages/de.js" /* webpackChunkName: "component---src-pages-de-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pl-js": () => import("./../../../src/pages/pl.js" /* webpackChunkName: "component---src-pages-pl-js" */),
  "component---src-pages-sk-js": () => import("./../../../src/pages/sk.js" /* webpackChunkName: "component---src-pages-sk-js" */),
  "component---src-pages-uk-js": () => import("./../../../src/pages/uk.js" /* webpackChunkName: "component---src-pages-uk-js" */)
}

